import React from 'react';
import { knowledgeBaseApi } from 'api/knowledgeBase';
import { KnowleedgeBaseContextProvider } from 'components/knowledgeBase/knowledgeBaseContext';
import { useProgramPanel } from 'contexts/programPanelContext';
import { ProgramKnowledgeBasePage } from 'components/programPanel/knowledgeBase/ProgramKnowledgeBasePage';

export const CoordinatorKnowledgeBaseContainer = () => {
	const { data: program, panelPath } = useProgramPanel();
	const linkPrefix = `/${panelPath}/knowledge-base`;

	return (
		<KnowleedgeBaseContextProvider
			context="coordinator"
			linkPrefix={linkPrefix}
			queries={{
				getArticleById: (articleId: number, params) =>
					knowledgeBaseApi.program.getProgramArticleByIdShow(Number(program?.id), articleId, params),
				getArticleInfo: (articleId: number) =>
					knowledgeBaseApi.program.getProgramArticleInfo(Number(program?.id), articleId),
				getProgramArticleVisitsDetails: (articleId: number) =>
					knowledgeBaseApi.program.getProgramArticleVisitsDetails(Number(program?.id), articleId),
				getArticlesByDirectory: (directoryId: number, searchValue?: string | null) =>
					knowledgeBaseApi.program.getArticlesForDirectory(Number(program?.id), directoryId, searchValue),
				getArticlesByTag: (tagId: number, searchValue?: string | null) =>
					knowledgeBaseApi.program.getArticlesForTag(Number(program?.id), tagId, searchValue),
				getArticlesBySearch: (searchValue?: string | null) =>
					knowledgeBaseApi.program.getProgramArticlesBySearch(Number(program?.id), searchValue),
				getDirectories: () => knowledgeBaseApi.program.getDirectories(Number(program?.id)),
				getRecommendedArticles: () =>
					knowledgeBaseApi.program.getProgramRecommendedArticles(Number(program?.id)),
				getProgramOrganizersArticles: () =>
					knowledgeBaseApi.program.getProgramOrganizersArticles(Number(program?.id)),
			}}
		>
			<ProgramKnowledgeBasePage />
		</KnowleedgeBaseContextProvider>
	);
};
